<template>
  <div class="container">
    <div class="bannerBox">
      <img
        src="../../../static/images/index/home_w.png"
        class="homeIcon"
        @click="toSpecialDetail"
      />
      <div
        class="banImg"
        :style="{ backgroundImage: `url(${mobileBanner})` }"
      ></div>
    </div>
    <div class="tab-box">最受关注{{ name }}</div>

    <div class="list-box">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getMobileLiveList"
      >
        <div class="lb_item" v-for="(item, index) in liveList" :key="index">
          <div class="l_item_left">
            <div
              class="triangle"
              :class="
                index == 0
                  ? 'first'
                  : index == 1
                  ? 'second'
                  : index == 2
                  ? 'third'
                  : ''
              "
            >
              {{ index + 1 }}
            </div>
            <div class="overFlowTwo">{{ item.Title }}</div>
            <div class="company">
              <img :src="item.HeadlineLogo" />
              <span>{{ item.Headline }}</span>
            </div>
          </div>
          <div class="l_item_right">
            <mini-program
              :path="
                '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
              "
            >
              <div class="lit_state">
                <div
                  class="lits_text"
                  :class="
                    item.Status == 1
                      ? 'orange'
                      : item.Status == 0
                      ? 'red'
                      : 'purple'
                  "
                >
                  <span>{{
                    item.Status == 0 ? "直播中" : item.StatusDesc
                  }}</span>
                </div>
                <div v-if="item.Status == 1" class="lits_time">
                  {{ item.StartDayDesc }}
                </div>
              </div>
              <img :src="item.Cover" class="coverImg" />
              <img
                src="../../../static/images/index/play.png"
                class="playIcon"
              />
            </mini-program>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { List } from "vant";
import { getShareData } from "@/utils/share";
import miniProgram from "@/components/miniProgram";
import { specialDetail, mobileLiveList } from "@/api/online";

export default {
  name: "lbRanking",
  components: {
    "van-list": List,
    miniProgram,
  },
  data() {
    return {
      name: "",
      sid: null, //专题id
      mobileBanner: "", //海报
      liveList: [],
      pageIndex: 1,
      total: 0,
      error: false,
      loading: false,
      finished: false,
    };
  },
  methods: {
    //跳转专题详情
    toSpecialDetail() {
      this.$router.replace({
        path: "/specificActDetail",
        query: { sid: this.$route.query.sid },
      });
    },

    //获取专题详情
    getSpecialDetail() {
      var that = this;
      var data = {
        SpecialId: Number(that.$route.query.sid),
      };
      specialDetail(data).then((res) => {
        that.mobileBanner = res.Data.MobileBanner;
        getShareData(
          window.location.href,
          "2026阿拉丁网上照明展",
          unescape(that.$route.query.name)
        );
      });
    },

    //获取直播列表
    getMobileLiveList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
        Recommend: that.$route.query.recommend,
        SpecialId: that.$route.query.sid,
        HasQrcode: 1,
      };
      mobileLiveList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.liveList = [...res.Data.List];
          } else {
            that.liveList = [...that.liveList, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.liveList.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },

  mounted() {
    this.sid = this.$route.query.sid;
    this.name = decodeURIComponent(this.$route.query.name);
    this.getSpecialDetail();
  },
};
</script>
<style scoped lang="less">
.bannerBox {
  height: 310px;
  position: relative;
  .homeIcon {
    position: absolute;
    z-index: 2;
    top: 12px;
    left: 11px;
    width: 30px;
    height: 30px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .banImg {
    display: block;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
  }
}
.tab-box {
  text-align: center;
  color: #333;
  font-size: 20px;
  font-weight: bold;
  line-height: 75px;
}

.list-box {
  padding-left: 8px;
}

.lb_item {
  display: flex;
  align-items: center;
  height: 98px;
  margin-bottom: 7px;
}

.l_item_left {
  width: 185px;
  height: 100%;
  background-color: #efefef;
  position: relative;
  color: #333333;
  font-size: 12px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.l_item_left .overFlowTwo {
  line-height: 17px;
}

.company {
  color: #666666;
  font-size: 9px;
  display: flex;
  align-items: center;
  margin-top: 9px;
}

.company img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 5px;
}

.triangle {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 19px;
  line-height: 23px;
  text-align: center;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 13px;
  font-weight: bold;
}

.triangle::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 34px solid #000000;
  border-right: 34px solid transparent;
}

.triangle.first::before {
  border-top-color: #ff3535;
}

.triangle.second::before {
  border-top-color: #ea5555;
}

.triangle.third::before {
  border-top-color: #993333;
}

.l_item_right {
  width: 175px;
  height: 100%;
  position: relative;
}

.lit_state {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #ffffff;
}

.lits_text {
  display: flex;
  align-items: center;
  height: 18px;
  padding: 0 5px;
}

.lits_text img {
  width: 15px;
  height: 15px;
  margin-right: 3px;
}

.lits_time {
  padding: 0 7px;
  line-height: 18px;
  background-color: rgba(255, 132, 0, 0.6);
}

.red {
  background-color: #ff3535;
}

.purple {
  background-color: #a421a6;
}

.orange {
  background-color: #ff8400;
}

.playIcon {
  width: 26px;
  height: 26px;
  position: absolute;
  z-index: 2;
  bottom: 3px;
  left: 3px;
}

.coverImg {
  width: 100%;
  height: 100%;
  display: block;
}
</style>